/**
 * Client-safe trust constants. Deliberately importless: compute.ts pulls in
 * Prisma, so importing this value from there into a "use client" component
 * dragged the database driver into the browser bundle and broke the build.
 *
 * The highest score actually attainable: 20 (KYC) + 15 (ID doc screened) +
 * 10 (phone) + 20 (title deed) + 10 (photos) + 10 (EAC on file) + 5 (description).
 *
 * It is 90, NOT 100 — the reverse-image `noDuplicates` check is not built and
 * scores nothing. The UI advertised "/100" everywhere, so a listing that had
 * passed every check we actually perform still read as 90/100, i.e. incomplete.
 */
export const MAX_TRUST_SCORE = 90
